import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

import { PAGE_CONFIG } from "./../../common/constant/pageconfig.constant";
import { REGISTER_BOOK_CONSTANT } from "./../constant/register-book.constants";
import { registerbookInterface } from "./../register-book.interface";

@Injectable({
  providedIn: "root",
})
export class RegisterBookService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private http: HttpClient) {}
  
  // Get register data by status
  public getRegisterDataByStatus(status: string, obj) {
    return this.http.post(
      `${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_TAB_DATA}/${status}`,
      obj
    );
  }

  public registerDataByStatus(status: string) {
    return this.http.post(
      `${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_TAB_DATA}/${status}`,
      {}
    );
  }

  // Basic Services
  public createRegisterBookData(registerBookData: registerbookInterface) {
    return this.http.post(
      `${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_CREATE}`,
      registerBookData
    );
  }

  public getBookData() {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_DATA}`);
  }

  public getEntryData(filters) {
    return this.http.post(
      `${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_LIST}`,
      filters
    );
  }

  public getEntryEdit(entryId: any) {
    return this.http.get(
      `${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_DATA}/${entryId}`
    );
  }

  public updateData(registerBookData: registerbookInterface) {
    let regBookId = registerBookData.id;
    return this.http.put(
      `${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_DATA}/${regBookId}`,
      registerBookData
    );
  }

  public updateEntry(registerBookData: registerbookInterface) {
    let entryId = registerBookData.id;
    return this.http.put(
      `${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_DATA}/${entryId}${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_ASSEMBLY}`,
      registerBookData
    );
  }

  // Other services
  public getAssemblyData() {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.ASSEMBLIES_LIST}`);
  }

  public getGaonData(assemblyId: any) {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.GAON_LIST}/${assemblyId}`);
  }

  public getGatNumberData(gatId: any) {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.GATNO_LIST}/${gatId}`);
  }

  public getGanNumberData(ganId: any) {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.GAN_NUMBER_LIST}/${ganId}`);
  }

  public getLetterType() {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.REGISTER_BOOK_LETTERTYPE}`);
  }

  public sendSms(type, obj: any) {
    return this.http.post(`${REGISTER_BOOK_CONSTANT.SEND_SMS}/${type}`, obj);
  }

  public totalCount() {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.TOTAL_COUNT}`);
  }

  public totalCountByType(type: string) {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.TOTAL_COUNT}/${type}`);
  }

  public getDepartment() {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.DEPARTMENT}`);
  }

  public getCast() {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.CAST}`);
  }

  public getSubLetters() {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.SUB_LETTER_TYPES}`);
  }

  public getRegisterDocuments() {
    return this.http.get(`${REGISTER_BOOK_CONSTANT.CREATE_DOCUMENTS}`);
  }

  public createRegisterDocuments(templateData: any) {
    return this.http.post(
      `${REGISTER_BOOK_CONSTANT.CREATE_DOCUMENTS}`,
      templateData
    );
  }

  public documentsDataList(documentId) {
    return this.http.get(
      `${REGISTER_BOOK_CONSTANT.DOCUMENTS_LIST}/${documentId}`,
      { headers: { Accept: "application/pdf" }, responseType: "blob" }
    );
  }

  public getRegisterBookDocuments(registerBookId) {
    return this.http.get(
      `${REGISTER_BOOK_CONSTANT.CREATED_DOCUMENTS_LIST}/${registerBookId}`
    );
  }

  public getPageConfig() {
    return this.http.get(PAGE_CONFIG.Register_Page);
  }

  public updateEntryStatus(data) {
    return this.http.put(`${REGISTER_BOOK_CONSTANT.WORK_STATUS}`, data);
  }

  
  public getCSV(payload) {
    return this.http.post(`/register-book/export`, payload, {
      headers: { Accept: "application/pdf" },
      responseType: "blob",
    });
  }
  

  public addComment(data) {
    return this.http.post(
      `${REGISTER_BOOK_CONSTANT.REGISTER_ADD_COMMENT}`,
      data
    );
  }

  // getRegisterBooks(filterObj: any): Observable<any> {
  //   return this.http.get(`/api/register-books`, { params: filterObj });
  // }

  // Fetch available fields from API
  public getExcelFields() {
    return this.http.get<any[]>(`/register-book/export/fields`);
  }
  public restoreRecord(rowData: any) {
    return this.http.patch(`/register-book/restore/${rowData.id}`, {});
  }
  public savecontent(registerBookObj: any) {
    return this.http.post('/register-book/create', registerBookObj);
  }
  
  public downloadLetterInPdf(registerBookObj: any): Observable<any> {
    return this.http.post(`/register-book-pdf/download`, registerBookObj, {
      headers: { Accept: "application/pdf" },
      responseType: "blob",
    });    
  }
  }
